import React, { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import { Provider } from "react-redux";
import { store } from './store/index';
import GlobalStyle from './styles/globalStyles';

import './styles/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const App: FC = () => (
  <Provider store={store}>
    <GlobalStyle />
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </Provider>
);

export default App;
